<script setup lang="ts">
    import { CheckIcon } from '@lucide/vue';

    defineProps<{
        message: string;
    }>();
</script>
<template>
    <div class="aspect-video relative">
        <CheckIcon
            class="w-[80%] h-auto absolute top-1/2 left-1/2 -translate-1/2 text-success opacity-40 pointer-events-none"
        />
        <h2
            class="text-xl font-medium mb absolute top-1/2 left-0 -translate-y-1/2 w-full text-center"
        >
            {{ message }}
        </h2>
    </div>
</template>
